import {Page} from "pansx-utils";
import {RealTimeInfo} from "@/entity/RealTimeInfo";
const enum RealInfoTypeEnum{
    STAR='01',
    LAYERS='02',
    TOPIC='03'
}
export default class RealTimeInfoReq{
    public content: RealTimeInfo[] = [];
    public page = 1;
    public size = 5;
    public infoType = '';
    public userName = '';
    public companyCreditCode = '';
    public userIdentity = '';
    public companyId = '';
    public resCode?: number;
    public totalElements = 0;
    public totalPages = 0;
    public getRealInfoType(value: string){
        if('star'===value){
            return RealInfoTypeEnum.STAR;
        }
        if('layers'===value){
            return RealInfoTypeEnum.LAYERS;
        }
        if ('topic'===value){
            return RealInfoTypeEnum.TOPIC;
        }
        return undefined;
    }
}